module.exports = __webpack_public_path__ + "img/pets_12128.a2c3357a.png";